import React, { useState, useEffect } from "react";

import Grid from "@material-ui/core/Grid";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";

import { useHistory } from "react-router-dom";

import api from "../../services/api";
import { notify } from "../../utils/notify";
import MaskService from "../../utils/mask/maskService";
import ModalLoading from "../../components/modalLoading/ModalLoading";
import validatesNotNull from "../../utils/validatesNotNull";
import { GlobalVariables } from "../../global";
import TextFieldCustom from "../../components/basic/TextFieldCustom";
import SelectCustom from "../../components/basic/SelectCustom";
import { changedValues } from "../../utils/changedValues";
import "./.promoter.css";

const UpdatePromoter = ({ location }) => {
  const { goBack } = useHistory();
  const [loading, setLoading] = useState(false);
  const [reason, setReason] = useState(location.state.row.Razao);
  const [fantasy, setFantasy] = useState(location.state.row.Fantasia);
  const [cnpj, setCnpj] = useState(location.state.row.CNPJ);
  const [cnpjMatriz, setCnpjMatriz] = useState(
    location.state.row.MatrizCNPJ || ""
  );
  const [ie, setIe] = useState(location.state.row.IE || "");
  const [im, setIm] = useState(location.state.row.IM || "");
  const [cep, setCep] = useState("");
  const [uf, setUf] = useState("");
  const [county, setCounty] = useState("");
  const [address, setAddress] = useState("");
  const [number, setNumber] = useState("");
  const [district, setDistrict] = useState("");
  const [complement, setComplement] = useState("");
  const [telephone, setTelephone] = useState("");
  const [crc, setCrc] = useState(location.state.row.CRC || "");
  const [disableCRC, setDisableCRC] = useState(
    location.state.row.CRC ? false : true
  );
  const [errors, setErrors] = useState({});

  const [typePromoter, setTypePromoter] = useState(null);
  const [status, setStatus] = useState(null);
  const [optionsTypePromoters, setOptionsTypePromoters] = useState([]);
  const [optionsStatus, setOptionsStatus] = useState([]);
  const [active, setActive] = useState(false);
  const [initialState, setInitialState] = useState({});

  useEffect(() => {
    const getData = async () => {
      try {
        setLoading(true);

        const cnpjRemoveMask = location.state.row.CNPJ;
        const { data: result } = await api.get(
          `promotor/dadosParaCriarPromotor/${cnpjRemoveMask.replace(
            /[^0-9]+/g,
            ""
          )}`
        );
        const data = result.data;

        const copyInitial = {
          MatrizCNPJ: location.state.row.MatrizCNPJ || "",
          Fantasia: location.state.row.Fantasia,
          IE: location.state.row.IE || "",
          IM: location.state.row.IM || "",
          CEP: location.state.row.CEP,
          Municipio: location.state.row.Municipio,
          UF: location.state.row.UF,
          Endereco: location.state.row.Endereco,
          Numero: location.state.row.Numero,
          Bairro: location.state.row.Bairro,
          Complemento: location.state.row.Complemento || "",
          Telefone: location.state.row.Telefone,
          CRC: location.state.row.CRC || "",
          IdTipoPromotor: location.state.row.IdTipoPromotor,
          IdStatus: location.state.row.IdStatus,
          Razao: location.state.row.Razao,
          RemoverLogo: false,
        };
        setInitialState(
          Object.assign(copyInitial, {
            MatrizCNPJ: data.company.MatrizCNPJ,
            CEP: data.company.CEP,
            Municipio: data.company.Municipio,
            UF: data.company.UF,
            Endereco: data.company.Endereco,
            Numero: data.company.Numero,
            Bairro: data.company.Bairro,
            Complemento: data.company.Complemento || "",
            Telefone: data.company.Telefone,
          })
        );

        setCnpjMatriz(data.company.MatrizCNPJ || "");
        setActive(data.company.MatrizCNPJ ? true : false);
        setCep(data.company.CEP);
        setCounty(data.company.Municipio);
        setUf(data.company.UF);
        setAddress(data.company.Endereco);
        setNumber(data.company.Numero);
        setDistrict(data.company.Bairro);
        setComplement(data.company.Complemento || "");
        setTelephone(data.company.Telefone);
        setOptionsStatus(data.status);
        setOptionsTypePromoters(data.typePromoters);
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };
    getData();
  }, [location.state.row]);

  useEffect(() => {
    const getDataByCEP = async () => {
      setLoading(true);
      try {
        const cepRemoveMask = cep;

        const { data } = await api.get(
          `cliente/cep/${cepRemoveMask.replace(/[^0-9]+/g, "")}/hubDev`
        );

        if (data && data.bairro) {
          setDistrict(data.bairro);
          setComplement(data.complemento || "");
          setCounty(data.localidade);
          setAddress(data.logradouro);
          setUf(data.uf);
        }

        setLoading(false);
        return data;
      } catch (error) {
        setLoading(false);

        notify("Não foi possível encontrar dados do CNPJ/CPF informado.");
      }
    };

    if (cep && cep.length === 10) {
      getDataByCEP();
    }
  }, [cep]);

  useEffect(() => {
    const typePromoterSelected = optionsTypePromoters.find(
      (op) => op.Id === location.state.row.IdTipoPromotor
    );
    if (typePromoterSelected) {
      setTypePromoter(typePromoterSelected);
      setStatus(
        optionsStatus.find(
          (statusItem) => statusItem.Id === location.state.row.IdStatus
        )
      );
    }
  }, [location.state.row, optionsTypePromoters, optionsStatus]);

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      setLoading(true);

      let validationFail = false;

      const requiredInputs = [
        { value: reason, key: "reason" },
        { value: fantasy, key: "fantasy" },
        { value: cep, key: "cep" },
        { value: uf, key: "uf" },
        { value: county, key: "county" },
        { value: address, key: "address" },
        { value: number, key: "number" },
        { value: district, key: "district" },
        { value: telephone, key: "telephone" },
        { value: status, key: "status" },
      ];

      if (active) {
        requiredInputs.push({ value: cnpjMatriz, key: "cnpjMatriz" });
      }

      const resultValidation = validatesNotNull(requiredInputs);

      if (cep && MaskService.toMask("cep", cep).length !== 10) {
        validationFail = true;
        resultValidation.errorsValidation.cep = true;
        notify("O CEP informado é inválido.", true, "error");
      }

      if (telephone && !MaskService.isValid("cel-phone", telephone)) {
        validationFail = true;
        resultValidation.errorsValidation.telephone = true;
        notify("O telefone informado é inválido.", true, "error");
      }

      if (active && cnpjMatriz && !MaskService.isValid("cnpj", cnpjMatriz)) {
        validationFail = true;
        resultValidation.errorsValidation.cnpjMatriz = true;
        notify("O CNPJ da matriz informado é inválido.", true, "error");
      }

      if (resultValidation.error || validationFail) {
        setErrors(resultValidation.errorsValidation);
        return setLoading(false);
      } else {
        setErrors({});
      }

      let cnpjRemoveMask = location.state.row.CNPJ;
      cnpjRemoveMask = cnpjRemoveMask.replace(/[^0-9]+/g, "");
      let telRemoveMask = telephone;
      let cepRemoveMask = cep;
      let cnpjMatrizRemoveMask = cnpjMatriz;

      const body = changedValues({
        initial: initialState,
        current: {
          MatrizCNPJ: active ? cnpjMatrizRemoveMask : null,
          Fantasia: fantasy.substr(0, 60),
          IE: ie,
          IM: im,
          CEP: cepRemoveMask,
          Municipio: county.substr(0, 50),
          UF: uf.substr(0, 2),
          Endereco: address.substr(0, 50),
          Numero: number.substr(0, 50),
          Bairro: district.substr(0, 50),
          Complemento: complement.substr(0, 50),
          Telefone: telRemoveMask,
          CRC: crc.substr(0, 50),
          IdTipoPromotor: typePromoter.Id,
          IdStatus: status.Id,
          Razao: reason.substr(0, 90),
        },
      });

      if (Object.keys(body).length < 1) return setLoading(false);

      const { data: result } = await api.put(
        `promotor/${cnpjRemoveMask}`,
        body
      );

      if (result.success) {
        setInitialState(Object.assign(initialState, body));
        notify("Promotor atualizado com sucesso.", true, "info");
        goBack();
      }
      setLoading(false);
    } catch (error) {
      console.error("ERROR: UpdatePromoter", error);
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      {loading && <ModalLoading loading={loading} />}
      <Grid
        container
        alignItems="center"
        justify="center"
        className="wrapper fadeInDown"
      >
        <Grid
          container
          spacing={2}
          alignItems="center"
          justify="flex-start"
          item
          lg={9}
          md={10}
          sm={10}
          xs={11}
          id="formContent"
        >
          <Grid
            item
            lg={12}
            md={12}
            sm={12}
            xs={12}
            container
            alignItems="center"
            justify="center"
          >
            <ArrowBackIcon className="iconGoBack" onClick={goBack} />
            <label className="title">Edição do promotor</label>
          </Grid>

          <Grid item lg={4} md={4} sm={12} xs={12}>
            <TextFieldCustom
              disabled
              label={cnpj.length === 14 ? "CNPJ*" : "CPF*"}
              type="text"
              value={MaskService.toMask(
                cnpj.length === 14 ? "cnpj" : "cpf",
                cnpj
              )}
              setValue={setCnpj}
              mask={cnpj.length === 14 ? "cnpj" : "cpf"}
              error={errors.cnpj}
            />
          </Grid>

          <Grid item lg={4} md={4} sm={6} xs={6}>
            <TextFieldCustom
              maxLength={50}
              autoFocus
              label="IE"
              type="text"
              value={ie}
              setValue={setIe}
              error={errors.ie}
            />
          </Grid>

          <Grid item lg={4} md={4} sm={6} xs={6}>
            <TextFieldCustom
              maxLength={50}
              label="IM"
              type="text"
              value={im}
              setValue={setIm}
              error={errors.im}
            />
          </Grid>

          <Grid item lg={6} md={6} sm={12} xs={12}>
            <TextFieldCustom
              maxLength={120}
              label="Fantasia*"
              type="text"
              value={fantasy}
              setValue={setFantasy}
              error={errors.fantasy}
            />
          </Grid>

          <Grid item lg={6} md={6} sm={12} xs={12}>
            <TextFieldCustom
              maxLength={120}
              label="Razão*"
              type="text"
              value={reason}
              setValue={setReason}
              error={errors.reason}
            />
          </Grid>

          <Grid item lg={4} md={4} sm={4} xs={12}>
            <TextFieldCustom
              label="CEP*"
              type="text"
              mask="cep"
              value={MaskService.toMask("cep", cep)}
              setValue={setCep}
              error={errors.cep}
            />
          </Grid>

          <Grid item lg={6} md={6} sm={6} xs={12}>
            <TextFieldCustom
              maxLength={50}
              label="Município*"
              type="text"
              value={county}
              setValue={setCounty}
              error={errors.county}
            />
          </Grid>

          <Grid item lg={2} md={2} sm={2} xs={12}>
            <TextFieldCustom
              label="UF*"
              type="text"
              value={uf}
              onChange={(e) => {
                if (e.target.value.length < 3) {
                  setUf(e.target.value.toString().toUpperCase());
                }
              }}
              error={errors.uf}
            />
          </Grid>

          <Grid item lg={6} md={6} sm={12} xs={12}>
            <TextFieldCustom
              maxLength={50}
              label="Endereço*"
              type="text"
              value={address}
              setValue={setAddress}
              error={errors.address}
            />
          </Grid>

          <Grid item lg={3} md={3} sm={6} xs={12}>
            <TextFieldCustom
              maxLength={50}
              label="Número*"
              type="text"
              value={number}
              setValue={setNumber}
              error={errors.number}
            />
          </Grid>

          <Grid item lg={3} md={3} sm={6} xs={12}>
            <TextFieldCustom
              maxLength={50}
              label="Bairro*"
              type="text"
              value={district}
              setValue={setDistrict}
              error={errors.district}
            />
          </Grid>

          <Grid item lg={4} md={4} sm={6} xs={12}>
            <TextFieldCustom
              maxLength={50}
              label="Complemento"
              type="text"
              value={complement}
              setValue={setComplement}
              error={errors.complement}
            />
          </Grid>

          <Grid item lg={4} md={4} sm={6} xs={12}>
            <TextFieldCustom
              label="Telefone*"
              type="text"
              value={MaskService.toMask("cel-phone", telephone)}
              mask="cel-phone"
              setValue={setTelephone}
              error={errors.telephone}
            />
          </Grid>

          <Grid item lg={4} md={4} sm={12} xs={12}>
            <SelectCustom
              disabled
              label="Tipo de promotor*"
              keyObject="Nome"
              value={typePromoter}
              onChange={(value) => {
                setTypePromoter(value);
                if (
                  value.Id === parseInt(GlobalVariables.TIPO_PROMOTOR_CONTADOR)
                ) {
                  setDisableCRC(false);
                } else {
                  setDisableCRC(true);
                  setCrc("");
                }
              }}
              error={errors.typePromoter}
              optionsList={optionsTypePromoters}
            />
          </Grid>

          <Grid item lg={4} md={4} sm={6} xs={12}>
            <TextFieldCustom
              disabled={disableCRC}
              maxLength={50}
              label="CRC"
              type="text"
              value={crc}
              setValue={setCrc}
              error={errors.crc}
            />
          </Grid>

          <Grid item lg={4} md={4} sm={6} xs={12}>
            <SelectCustom
              label="Status*"
              keyObject="Nome"
              value={status}
              setValue={setStatus}
              error={errors.status}
              optionsList={optionsStatus}
            />
          </Grid>

          <Grid item lg={4} md={4} sm={6} xs={12}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={active}
                  onChange={() => {
                    setCnpjMatriz("");
                    setActive(!active);
                  }}
                  name="checkedB"
                  className="checkboxColor"
                />
              }
              label="Vincular matriz"
            />
          </Grid>

          {active && (
            <Grid item lg={4} md={4} sm={6} xs={12}>
              <TextFieldCustom
                label="CNPJ Matriz*"
                type="text"
                value={cnpjMatriz}
                mask="cnpj"
                setValue={setCnpjMatriz}
                error={errors.cnpjMatriz}
              />
            </Grid>
          )}

          <Grid item lg={12} md={12} sm={12} xs={12}>
            <button
              id="buttonStylePromocode"
              type="submit"
              className="btn btn-info"
            >
              Salvar
            </button>
          </Grid>
        </Grid>
      </Grid>
    </form>
  );
};

export default UpdatePromoter;
